import React from 'react'

export default () => (
	<div>
		<p>Something went wrong. We couldn't find the page you were looking for.</p>
	</div>
)